
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ForgotPasswordModal from "@/components/modals/forms/ResetPassword.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "login-component",
  components: {
    Field,
    Form,
    ErrorMessage,
    ForgotPasswordModal,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLButtonElement | null>(null);
    const regButton = ref<HTMLLinkElement | null>(null);
    Yup.setLocale({
      mixed: {
        required: "* กรุณาป้อนข้อมูล",
      },
    });
    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string()
        .required("* กรุณาป้อนเบอร์โทรศัพท์")
        .min(10, "* เบอร์โทรศัพท์ไม่ถูกต้อง")
        .label("เบอร์โทรศัพท์"),
      password: Yup.string().required("* กรุณาป้อนรหัสผ่าน").label("รหัสผ่าน"),
    });
    //Form submit function
    const onSubmitLogin = async (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      await store.dispatch(Actions.LOGIN, values);
      const error = store.getters.getErrors;
      if (!error) {
        router.push({ name: "dashboard" });
      } else {
        Swal.fire({
          text: error.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }

      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    const checkRegis = async () => {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("reg")) {
        regButton.value?.click();
      }
    };

    onMounted(async () => {
      nextTick(async () => {
        await store.dispatch(Actions.GET_APPINFO);
      });
      nextTick(async () => {
        await checkRegis();
      });
    });
    return {
      onSubmitLogin,
      login,
      submitButton,
      regButton,
      checkRegis,
    };
  },
});
